import appError from './appError.js';
import readArguments from './readArguments.js';
import isObject from './isObject.js';

export default {

	/**
	 * Parse JSON safely
	 * @param {string} jsonString
	 * @param {Function} [reviver]
	 * @returns {*}
	 */
	parse(jsonString, reviver) {
		if (typeof jsonString === 'string') {
			try {
				return JSON.parse(jsonString, reviver);
			} catch (error) {
				appError(error, {
					code: 'APP_SHARED_UTIL',
					origin: 'json.parse',
					detail: readArguments(arguments) // @todo update detail structure
				});
				return null;
			}
		} else {
			throw appError('Invalid method arguments to json.parse', {
				code: 'APP_SHARED_UTIL',
				origin: 'json.parse',
				detail: readArguments(arguments) // @todo update detail structure
			});
		}
	},

	/**
	 * Converting circular structure to JSON
	 * @returns {object|number|string}
	 */
	circularReplacer() {
		const seen = new WeakSet();
		return (key, value) => {
			if (isObject(value)) {
				if (seen.has(value)) {
					return;
				}
				seen.add(value);
			}
			return value; // eslint-disable-line consistent-return
		};
	},

	/**
	 * Stringify JSON safely
	 * @param {*} jsonObject
	 * @param {Function} [replacer]
	 * @param {string|number} [space]
	 * @returns {string}
	 */
	stringify(jsonObject, replacer, space) {
		if (typeof jsonObject !== 'undefined') {
			try {
				return JSON.stringify(jsonObject, replacer, space);
			} catch (error) {
				appError(error, {
					code: 'APP_SHARED_UTIL',
					origin: 'json.stringify',
					detail: readArguments(arguments) // @todo update detail structure
				});
				return '';
			}
		} else {
			throw appError('Invalid method arguments to json.stringify', {
				code: 'APP_SHARED_UTIL',
				origin: 'json.stringify',
				detail: readArguments(arguments) // @todo update detail structure
			});
		}
	}

};
